import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./js/App";
import * as serviceWorker from "./serviceWorker";
import swConfig from "./swConfig";
import { enableEdgeToEdgeViewport, isNativeApp } from "./js/native/nativeApp";

enableEdgeToEdgeViewport();

createRoot(document.getElementById("root")!).render(<App />);

// The apps already ship every file with the build, so they need no service worker.
if (!isNativeApp) {
  serviceWorker.register(swConfig);
}
